/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';

import {
    DEFAULT_PACKAGE_TYPES,
    PACKAGE_ONE,
    PACKAGE_TWO,
} from '../constants/main';

import './pricingCalculatorBanner.scss';

export default class PricingCalculatorBanner extends PureComponent {
    static propTypes = {
        currentPackage: PropTypes.oneOf(DEFAULT_PACKAGE_TYPES).isRequired,
        handleCTAClick: PropTypes.func.isRequired,
    };

    static defaultProps = {
        currentPackage: PACKAGE_TWO,
    };

    _handleClick = (e) => {
        if (e.target.id === 'assortmentLink') {
            this.props.handleCTAClick();
        }
    };

    renderOppositePackageCTA = () => {
        let markup = gettext(
            '<h4>For simpler ticketing and lower fees, try calculating your payout using the <a id="assortmentLink" class="eds-btn--link eds-btn--anchor eds-link">Essentials package</a>.</h4>',
        );

        if (this.props.currentPackage === PACKAGE_ONE) {
            markup = gettext(
                '<h4>For more advanced ticketing needs try calculating your payout using the <a class="eds-btn--link eds-btn--anchor eds-link" id="assortmentLink">Professional package</a>.</h4>',
            );
        }

        /* eslint-disable react/no-danger */
        return <div dangerouslySetInnerHTML={{ __html: markup }} />;
    };
    render() {
        return (
            <div className="eds-g-cell eds-g-cell-1-1 eds-g-group--full-width eds-bg-color--secondary-brand pricing-calculator-banner">
                <div
                    className="eds-align--center eds-text--center pricing-calculator-banner--content eds-text-hs eds-text-color--inverse-primary-brand eds-pad-hor-6"
                    onClick={this._handleClick}
                    role="button"
                >
                    {this.renderOppositePackageCTA()}
                </div>
            </div>
        );
    }
}
